import React from 'react';
import style from './ModeDisplayBar.module.scss';
const { REACT_APP_MODE: mode = '' } = process.env;

const ModeDisplayBarLogin = () => {
  return (
    <>{mode ? <div className={style.ModeDisplayBarLogin}>{mode}</div> : ''}</>
  );
};

export default ModeDisplayBarLogin;
